module.exports = __webpack_public_path__ + "static/image/history/pc/201403.jpg?5885660b";